import plugin from 'tailwindcss/plugin';
import colors from 'tailwindcss/colors';

export const tailwind = {
  mode: 'jit',
  content: ['./src/**/*.{html,js,svelte,ts}'],
  // purge: { OLD WAY
  //   content: ['./src/**/*.{svelte}'],
  // },
  // https://tailwindcss.com/docs/dark-mode#customizing-the-class-name
  // https://tailwindcss.com/docs/dark-mode#toggling-dark-mode-manually
  // darkMode: `[data-theme='dark']`,
  theme: {
    debugScreens: {
      prefix: 'breakpoint: '
    },
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      black: colors.black,
      white: colors.white,
      red: '#C92120',
      'grey-light': '#F5F5F5',
      'grey-medium': '#E8E8E8',
      'grey-dark': '#E1E1E1',
    },
    screens: 
    {
      'xxs': '0px',
      'xs': '640px',
      'sm': '768px',
      'md': '1024px',
      'lg': '1280px',
      'xl': '1440px',
      'xxl': '1536px',
      'xxxl': '1920px',
    },
    extend: {},
  },
  // variants: {
  //   backgroundColor: ['hover', 'focus'],
  //   borderColor: ['focus', 'hover'],
  // },
  corePlugins: {
    preflight: false, // Turn of TW CSS Resets
  },
  plugins: [
    plugin(function ({ addComponents, theme }) 
    {
      // Toggle on-off as needed for dev...
      return;

      const screens = theme('screens');
      const userStyles = theme('debugScreens.style', {});
      const ignoredScreens = theme('debugScreens.ignore', ['dark']);
      const prefix = theme('debugScreens.prefix', 'screen: ');
      const selector = theme('debugScreens.selector', '.debug-screens');

    
      
      const components = {
        [`${selector}::before`]: Object.assign({
          position: 'fixed',
          zIndex: '2147483647',
          bottom: '0',
          right: '36px',
          padding: '.6em .5em',
          fontSize: '12px',
          lineHeight: '1',
          fontFamily: 'sans-serif',
          backgroundColor: '#000',
          color: '#fff',
          //boxShadow: '0 0 0 1px #fff',
          content: `'${prefix}_'`,
        }, userStyles),
      };
    
      Object.entries( screens )
        .filter(([ _screens ]) => !ignoredScreens.includes( _screens ))
        .forEach(([ _screens ]) => 
        {

          components[`@screen ${ _screens }`] = 
          {
            [`${selector}::before`]: {
              content: `'${prefix}${ _screens } : ${ theme( 'screens.' + _screens )}'`,
            },
          };

        });
    
      addComponents(components);
    })
  ],
}
